// assets/tabbed-collection.js
(function () {
  'use strict';

  function initTabbedCollection(section) {
    if (!section || section.dataset.initialized === 'true') return;

    // Tab switching
    const tabButtons = section.querySelectorAll('.tabbed-collection__tab-button');
    const tabContents = section.querySelectorAll('.tabbed-collection__content');
    const viewAllBtn = section.querySelector('[data-view-all-btn]');

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const tabId = button.dataset.tabId;

        tabButtons.forEach(btn => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');

        let activeScroller = null;
        tabContents.forEach(content => {
          content.classList.remove('active');
          if (content.dataset.tabId === tabId) {
            content.classList.add('active');
            const scroller = content.querySelector('.tabbed-collection__products-scroller');
            if (scroller) activeScroller = scroller;
          }
        });
        const viewAllUrl = button.dataset.viewAllUrl;
        if (viewAllBtn && viewAllUrl) {
          viewAllBtn.href = viewAllUrl;
        }
        if (viewAllBtn) {
          const tabText = button.dataset.viewAllText?.trim();
          viewAllBtn.textContent = tabText || viewAllBtn.dataset.defaultViewAllText || '';
        }
      });
    });

    const scrollers = section.querySelectorAll('.tabbed-collection__products-scroller');

    scrollers.forEach((scroller) => {
      const carousel = scroller.closest('.tabbed-collection__carousel');
      if (!carousel) return;

      const prevBtn = carousel.querySelector('.tabbed-collection__prev-btn');
      const nextBtn = carousel.querySelector('.tabbed-collection__next-btn');
      if (!prevBtn || !nextBtn) return;

      const getScrollAmount = () => {
        const firstChild = scroller.children[0];
        if (!firstChild) return 300;
        const cardWidth = firstChild.getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(scroller).gap) || 24;
        return Math.round(cardWidth + gap);
      };

      prevBtn.addEventListener('click', () => scroller.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => scroller.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }));

      const firstCard = scroller.children[0];
      const lastCard = scroller.children[scroller.children.length - 1];
      if (!firstCard || !lastCard) return;

      // IntersectionObserver replaces scroll-event + scrollLeft/clientWidth/scrollWidth reads.
      // Fires when first/last card enters or leaves the scroller viewport — no layout reads.
      const navIO = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === firstCard) prevBtn.disabled = entry.isIntersecting;
          if (entry.target === lastCard) nextBtn.disabled = entry.isIntersecting;
        });
        carousel.classList.toggle(
          'tabbed-collection__carousel--nav-hidden',
          prevBtn.disabled && nextBtn.disabled
        );
      }, { root: scroller, threshold: 0.95 });
      navIO.observe(firstCard);
      navIO.observe(lastCard);
    });

    section.dataset.initialized = 'true';
  }

  function initializeAllSections() {
    document.querySelectorAll('.tabbed-collection-carousel:not([data-initialized="true"])').forEach(initTabbedCollection);
  }

  document.addEventListener('DOMContentLoaded', initializeAllSections);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('tabbed-collection-carousel')) initTabbedCollection(e.target);
  });
})();